import { Button, Dropdown, MenuProps } from "antd";
import { DownOutlined } from "@ant-design/icons";
import { useCallback, useMemo, useState } from "react";
import { useTotalsReport } from "../PrintModal/hooks/reports/useTotalsReport";
import { PrintModal } from "../PrintModal";

type PrintDropdownProps = {
  request: any;
};

export const PrintDropdown = ({ request }: PrintDropdownProps) => {
  const [printType, setPrintType] = useState<number>(0);

  const [isOpen, setIsOpen] = useState<boolean>(false);

  const handleDropdownClick = useCallback(
    (e: React.MouseEvent<HTMLDivElement, MouseEvent>) => {
      setIsOpen(true);
      setPrintType(+e.currentTarget.id);
    },
    []
  );

  const { isLoading, printTotalsReport } = useTotalsReport(request);

  const items: MenuProps["items"] = useMemo(
    () => [
      {
        key: 1,
        label: (
          <div id="1" onClick={printTotalsReport}>
            Totals
          </div>
        ),
      },
      {
        key: 2,
        label: (
          <div id="2" onClick={handleDropdownClick}>
            Batch
          </div>
        ),
      },
      {
        key: 3,
        label: (
          <div id="3" onClick={handleDropdownClick}>
            Payments
          </div>
        ),
      },
      {
        key: 4,
        label: (
          <div id="4" onClick={handleDropdownClick}>
            Disbursements
          </div>
        ),
      },
    ],
    [handleDropdownClick, printTotalsReport]
  );

  return (
    <>
      <Dropdown menu={{ items }} trigger={["click"]} disabled={isLoading}>
        <Button shape="round" className="d-inline-flex align-center">
          Print Report <DownOutlined />
        </Button>
      </Dropdown>

      <PrintModal
        isOpen={isOpen}
        setIsOpen={setIsOpen}
        contentType={printType}
        setContentType={setPrintType}
      />
    </>
  );
};
